import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { NEW_ID } from '../../../constants/automations';
import { selectAutomatedConnectionById } from '../../../store/selectors/automations';
import CreateAutomatedConnectionForm from '../CreateAutomatedConnectionForm/CreateAutomatedConnectionForm';
import EditAutomatedConnectionForm from '../EditAutomatedConnectionForm/EditAutomatedConnectionForm';

interface IProps {
  id: string;
  orgId: string;
  onClose?: () => void;
  closeRequestRef?: React.MutableRefObject<(() => void) | null>;
}

const ExistingAutomatedConnectionForm: React.FC<IProps> = ({ id, orgId, onClose, closeRequestRef }) => {
  const connectionSelector = useMemo(() => selectAutomatedConnectionById(orgId, id), [orgId, id]);
  const connection = useSelector(connectionSelector);

  return connection ? (
    <EditAutomatedConnectionForm
      key={connection.uid}
      connection={connection}
      orgId={orgId}
      onClose={onClose}
      closeRequestRef={closeRequestRef}
    />
  ) : null;
};

const AutomatedConnectionsForm: React.FC<IProps> = ({ id, orgId, onClose, closeRequestRef }) =>
  id === NEW_ID ? (
    <CreateAutomatedConnectionForm orgId={orgId} onClose={onClose} closeRequestRef={closeRequestRef} />
  ) : (
    <ExistingAutomatedConnectionForm id={id} orgId={orgId} onClose={onClose} closeRequestRef={closeRequestRef} />
  );

export default AutomatedConnectionsForm;
